import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetAllEnterprisesInterface {
  search: string;
}

export const useGetAllEnterprises = () => {
  const mutate = useMutation(({ search }: GetAllEnterprisesInterface) => {
    return get(`/external-api/get_all_enterprises/${search}`);
  });

  return mutate;
};

export default useGetAllEnterprises;
